var map = {
	"./pt/button.json": 3735,
	"./pt/calculations.json": 9176,
	"./pt/calculationsParams.json": 8555,
	"./pt/editProject.json": 9378,
	"./pt/info.json": 6903,
	"./pt/input.json": 2520,
	"./pt/message.json": 557,
	"./pt/projects.json": 2952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1749;